import BookingIcon from '@material-ui/icons/Settings';
import { default as React } from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';

const bookingConfiguratorPage = PageBlueprint.make({
  params: {
    routeRef: rootRouteRef,
    path: '/booking-configurator',
    title: 'Order Products',
    icon: React.createElement(BookingIcon),
    loader: () =>
      import('./components/ReorderComponent').then(m =>
        React.createElement(m.ReorderComponent),
      ),
  },
});

export const bookingConfiguratorPlugin = createFrontendPlugin({
  pluginId: 'booking-configurator',
  routes: {
    root: rootRouteRef,
  },
  extensions: [bookingConfiguratorPage],
});
